<template>

  <div class="d-flex align-center">

    <o-select
      :label="$t('titles.month')"
      :items="monthOptions"
      :model-value="model.month"
      @update:model-value="(newMonth: number) => maybeUpdate(model.with({month: newMonth}))"
      density="compact"
      style="min-width: 160px"
      hide-details
    />

    <o-select
      :label="$t('titles.year')"
      :items="yearOptions"
      :model-value="model.year"
      @update:model-value="(newYear: number) => maybeUpdate(model.with({year: newYear}))"
      class="ml-4"
      style="min-width: 120px"
      density="compact"
      hide-details
    />

    <v-btn
      icon="$prev"
      density="compact"
      @click="maybeUpdate(model.subtract({months: 1}))"
      class="ml-4"
    />

    <v-btn
      icon="$next"
      density="compact"
      @click="maybeUpdate(model.add({months: 1}))"
      class="ml-4"
    />

  </div>

</template>

<script setup lang="ts">

import { Temporal } from '@js-temporal/polyfill'
import { range } from 'underscore'

interface Props {
  beforeUpdate?: () => Promise<void>,
}

const props = withDefaults(defineProps<Props>(), {
  beforeUpdate: () => {
    return Promise.resolve()
  },
})

const model = defineModel<Temporal.PlainYearMonth>({required: true}) // TODO make computed?

const monthOptions = [
  {value: 1, title: 'January'},
  {value: 2, title: 'February'},
  {value: 3, title: 'March'},
  {value: 4, title: 'April'},
  {value: 5, title: 'May'},
  {value: 6, title: 'June'},
  {value: 7, title: 'July'},
  {value: 8, title: 'August'},
  {value: 9, title: 'September'},
  {value: 10, title: 'October'},
  {value: 11, title: 'November'},
  {value: 12, title: 'December'},
]

const thisYear = Temporal.Now.plainDateISO().year

const yearOptions = range(thisYear - 10, thisYear + 10).map(year => {
  return {value: year, title: year.toString()}
})

function maybeUpdate(newValue: Temporal.PlainYearMonth) {
  props.beforeUpdate().then(() => {
    model.value = newValue
  })
}

</script>
